import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

const CHARITY_NAME_MAX_LENGTH = 100;

interface IProps {
	changeCharityName: (value: string) => void;
	isCharityEnabled: boolean;
}

export const CharityNameField: React.FC<IProps> = React.memo(({ changeCharityName, isCharityEnabled }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: isCharityEnabled, whitespace: true, message: t('enterCharityName') },
			{
				max: CHARITY_NAME_MAX_LENGTH,
				message: t('charityNameIsTooLong', { value: CHARITY_NAME_MAX_LENGTH }),
			},
		],
		[t, isCharityEnabled],
	);

	return (
		<FormInput
			testId="CharityNameField"
			name="charityName"
			label="charityNameLabel"
			onChange={changeCharityName}
			validationRules={validationRules}
			disabled={!isCharityEnabled}
		/>
	);
});
